// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prize-v2-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
  overflow-y: auto;
}

.prize-v2-modal {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.prize-v2-modal-header {
  padding: 24px 30px;
  border-bottom: 2px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0;
}

.prize-v2-modal-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
}

.prize-v2-modal-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 32px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  padding: 0;
  line-height: 1;
}

.prize-v2-modal-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

.prize-v2-modal-content {
  padding: 30px;
  overflow-y: auto;
  flex: 1 1;
}

.prize-section {
  margin-bottom: 30px;
}

.prize-section h3 {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid #f0f0f0;
}

.prize-info-grid {
  display: grid;
  gap: 12px;
}

.prize-info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
}

.prize-info-item .label {
  font-weight: 500;
  color: #6c757d;
}

.prize-info-item .value {
  font-weight: 600;
  font-size: 18px;
  color: #2c3e50;
}

.prize-info-item .value.total-pot {
  color: #667eea;
  font-size: 24px;
}

/* Summary Grid */
.prize-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.summary-card {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.summary-card.saw-offs {
  background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);
}

.summary-card.skins {
  background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%);
  color: white;
}

.summary-card.skins .summary-label,
.summary-card.skins .summary-value {
  color: white;
}

.summary-card.users {
  background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
  color: white;
}

.summary-card.users .summary-label,
.summary-card.users .summary-value {
  color: white;
}

.summary-card.system {
  background: linear-gradient(135deg, #81ecec 0%, #00b894 100%);
}

.summary-card.house {
  background: linear-gradient(135deg, #fab1a0 0%, #ff7675 100%);
  color: white;
}

.summary-card.house .summary-label,
.summary-card.house .summary-value {
  color: white;
}

.summary-icon {
  font-size: 32px;
  opacity: 0.9;
}

.summary-content {
  flex: 1 1;
}

.summary-label {
  font-size: 12px;
  font-weight: 500;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-value {
  font-size: 20px;
  font-weight: 700;
  margin-top: 4px;
}

/* Rounds List */
.rounds-list {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
}

.round-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 8px;
  background: white;
  border-radius: 6px;
  border-left: 4px solid #667eea;
}

.round-item:last-child {
  margin-bottom: 0;
}

.round-label {
  font-weight: 600;
  color: #2c3e50;
  min-width: 80px;
}

.round-value {
  font-weight: 700;
  color: #667eea;
  font-size: 16px;
}

.carried-over {
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
}

/* Round Results */
.rounds-results {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.round-result-card {
  background: #f8f9fa;
  border-radius: 8px;
  border-top: 3px solid #667eea;
  overflow: hidden;
}

.round-header {
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.2s;
  gap: 12px;
}

.round-header:hover {
  background-color: #e9ecef;
}

.round-content {
  flex: 1 1;
  min-width: 0; /* Prevent flex item from overflowing */
}

.round-header h4 {
  margin: 0 0 12px 0;
  color: #667eea;
  font-size: 16px;
  font-weight: 600;
}

.round-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  align-items: center;
}

.detail-row {
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  gap: 6px;
}

.detail-row span:first-child {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  white-space: nowrap;
}

.detail-row .amount {
  font-weight: 600;
  color: #2c3e50;
  font-size: 13px;
  white-space: nowrap;
}

.expand-icon {
  font-size: 18px;
  color: #667eea;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
  margin-top: 4px; /* Align with first detail row */
}

.round-header:hover .expand-icon {
  transform: scale(1.1);
}

/* Player Breakdown */
.player-breakdown {
  border-top: 1px solid #dee2e6;
  padding: 16px;
  background: white;
}

.player-breakdown h5 {
  margin: 0 0 12px 0;
  color: #495057;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.no-players-message {
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-style: italic;
}

.no-players-message p {
  margin: 0;
  font-size: 14px;
}

.breakdown-table {
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}

.breakdown-header {
  display: grid;
  grid-template-columns: 2fr 1.5fr 1fr 1fr 1fr;
  gap: 1px;
  background: #667eea;
  color: white;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.breakdown-header > div {
  padding: 8px 6px;
  display: flex;
  align-items: center;
}

.breakdown-row {
  display: grid;
  grid-template-columns: 2fr 1.5fr 1fr 1fr 1fr;
  gap: 1px;
  background: white;
  transition: background-color 0.2s;
}

.breakdown-row:hover {
  background-color: #f8f9fa;
}

.breakdown-row:nth-child(even) {
  background-color: #f8f9fa;
}

.breakdown-row:nth-child(even):hover {
  background-color: #e9ecef;
}

.breakdown-row > div {
  padding: 8px 6px;
  display: flex;
  align-items: center;
  font-size: 13px;
  border-right: 1px solid #dee2e6;
}

.breakdown-row > div:last-child {
  border-right: none;
}

.col-player {
  flex-direction: column;
  align-items: flex-start !important;
}

.player-name {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 2px;
}

.skin-count {
  font-size: 11px;
  color: #6c757d;
  font-style: italic;
}

.col-user {
  color: #495057;
}

.user-name {
  font-weight: 500;
}

.col-skin {
  flex-direction: column;
  align-items: flex-start !important;
}

.skin-amount {
  font-weight: 600;
  color: #6c5ce7;
}

.skin-percentage {
  font-size: 11px;
  color: #6c757d;
}

.no-skin {
  color: #adb5bd;
  font-style: italic;
}

.col-sawoff {
  flex-direction: column;
  align-items: flex-start !important;
}

.sawoff-amount {
  font-weight: 600;
  color: #fdcb6e;
}

.no-sawoff {
  color: #adb5bd;
  font-style: italic;
}

.col-total {
  justify-content: flex-end !important;
}

.total-amount {
  font-weight: 700;
  color: #2c3e50;
  font-size: 14px;
}

/* Verification Section */
.verification-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
}

.verification-grid {
  display: grid;
  gap: 12px;
}

.verification-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: white;
  border-radius: 6px;
}

.verification-item .label {
  font-weight: 500;
  color: #6c757d;
}

.verification-item .value {
  font-weight: 700;
  font-size: 16px;
  color: #2c3e50;
}

.verification-item .value.success {
  color: #00b894;
}

.verification-item .value.error {
  color: #ff7675;
}

/* Prize Note */
.prize-note {
  background: #e3f2fd;
  border-left: 4px solid #2196f3;
  padding: 12px 16px;
  border-radius: 4px;
  margin-top: 20px;
}

.prize-note p {
  margin: 0;
  color: #1976d2;
  font-size: 14px;
}

/* Modal Footer */
.prize-v2-modal-footer {
  padding: 20px 30px;
  border-top: 2px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.btn-secondary {
  padding: 10px 24px;
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-secondary:hover {
  background: #5a6268;
}

/* Responsive */
@media (max-width: 768px) {
  .prize-v2-modal {
    max-width: 100%;
    margin: 10px;
  }

  .prize-summary-grid {
    grid-template-columns: 1fr;
  }

  .round-summary {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .prize-v2-modal-header h2 {
    font-size: 20px;
  }

  .breakdown-header,
  .breakdown-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .breakdown-header > div,
  .breakdown-row > div {
    padding: 6px 8px;
    border-right: none;
    border-bottom: 1px solid #dee2e6;
  }

  .breakdown-header > div:last-child,
  .breakdown-row > div:last-child {
    border-bottom: none;
  }

  .breakdown-header > div::before,
  .breakdown-row > div::before {
    content: attr(data-label) ": ";
    font-weight: 600;
    color: #6c757d;
    margin-right: 8px;
  }

  .breakdown-header > div::before {
    color: rgba(255, 255, 255, 0.8);
  }

  .col-player::before { content: "Player: "; }
  .col-user::before { content: "User: "; }
  .col-skin::before { content: "Skin: "; }
  .col-sawoff::before { content: "Saw-Off: "; }
  .col-total::before { content: "Total: "; }
}

@media (max-width: 480px) {
  .prize-v2-modal-content {
    padding: 20px;
  }

         .round-header {
           padding: 8px 12px;
           gap: 8px;
         }

  .expand-icon {
    width: 20px;
    height: 20px;
    font-size: 16px;
  }

  .player-breakdown {
    padding: 12px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/admin/modals/PrizeV2Modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY,EAAE,uCAAuC;AACvD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe,EAAE,gCAAgC;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;EACjC;;EAEA,sBAAsB,mBAAmB,EAAE;EAC3C,oBAAoB,iBAAiB,EAAE;EACvC,oBAAoB,iBAAiB,EAAE;EACvC,sBAAsB,oBAAoB,EAAE;EAC5C,qBAAqB,kBAAkB,EAAE;AAC3C;;AAEA;EACE;IACE,aAAa;EACf;;SAEO;WACE,iBAAiB;WACjB,QAAQ;SACV;;EAEP;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".prize-v2-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 20px;\n  overflow-y: auto;\n}\n\n.prize-v2-modal {\n  background: white;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 900px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.prize-v2-modal-header {\n  padding: 24px 30px;\n  border-bottom: 2px solid #e0e0e0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 12px 12px 0 0;\n}\n\n.prize-v2-modal-header h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.prize-v2-modal-close {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  font-size: 32px;\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n  padding: 0;\n  line-height: 1;\n}\n\n.prize-v2-modal-close:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.prize-v2-modal-content {\n  padding: 30px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.prize-section {\n  margin-bottom: 30px;\n}\n\n.prize-section h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.prize-info-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.prize-info-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.prize-info-item .label {\n  font-weight: 500;\n  color: #6c757d;\n}\n\n.prize-info-item .value {\n  font-weight: 600;\n  font-size: 18px;\n  color: #2c3e50;\n}\n\n.prize-info-item .value.total-pot {\n  color: #667eea;\n  font-size: 24px;\n}\n\n/* Summary Grid */\n.prize-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.summary-card {\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.summary-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n}\n\n.summary-card.saw-offs {\n  background: linear-gradient(135deg, #ffeaa7 0%, #fdcb6e 100%);\n}\n\n.summary-card.skins {\n  background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%);\n  color: white;\n}\n\n.summary-card.skins .summary-label,\n.summary-card.skins .summary-value {\n  color: white;\n}\n\n.summary-card.users {\n  background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);\n  color: white;\n}\n\n.summary-card.users .summary-label,\n.summary-card.users .summary-value {\n  color: white;\n}\n\n.summary-card.system {\n  background: linear-gradient(135deg, #81ecec 0%, #00b894 100%);\n}\n\n.summary-card.house {\n  background: linear-gradient(135deg, #fab1a0 0%, #ff7675 100%);\n  color: white;\n}\n\n.summary-card.house .summary-label,\n.summary-card.house .summary-value {\n  color: white;\n}\n\n.summary-icon {\n  font-size: 32px;\n  opacity: 0.9;\n}\n\n.summary-content {\n  flex: 1;\n}\n\n.summary-label {\n  font-size: 12px;\n  font-weight: 500;\n  opacity: 0.9;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.summary-value {\n  font-size: 20px;\n  font-weight: 700;\n  margin-top: 4px;\n}\n\n/* Rounds List */\n.rounds-list {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.round-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  margin-bottom: 8px;\n  background: white;\n  border-radius: 6px;\n  border-left: 4px solid #667eea;\n}\n\n.round-item:last-child {\n  margin-bottom: 0;\n}\n\n.round-label {\n  font-weight: 600;\n  color: #2c3e50;\n  min-width: 80px;\n}\n\n.round-value {\n  font-weight: 700;\n  color: #667eea;\n  font-size: 16px;\n}\n\n.carried-over {\n  font-size: 12px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* Round Results */\n.rounds-results {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.round-result-card {\n  background: #f8f9fa;\n  border-radius: 8px;\n  border-top: 3px solid #667eea;\n  overflow: hidden;\n}\n\n.round-header {\n  padding: 8px 16px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: background-color 0.2s;\n  gap: 12px;\n}\n\n.round-header:hover {\n  background-color: #e9ecef;\n}\n\n.round-content {\n  flex: 1;\n  min-width: 0; /* Prevent flex item from overflowing */\n}\n\n.round-header h4 {\n  margin: 0 0 12px 0;\n  color: #667eea;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.round-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 24px;\n  align-items: center;\n}\n\n.detail-row {\n  display: inline-flex;\n  align-items: center;\n  font-size: 13px;\n  gap: 6px;\n}\n\n.detail-row span:first-child {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.detail-row .amount {\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.expand-icon {\n  font-size: 18px;\n  color: #667eea;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s;\n  margin-top: 4px; /* Align with first detail row */\n}\n\n.round-header:hover .expand-icon {\n  transform: scale(1.1);\n}\n\n/* Player Breakdown */\n.player-breakdown {\n  border-top: 1px solid #dee2e6;\n  padding: 16px;\n  background: white;\n}\n\n.player-breakdown h5 {\n  margin: 0 0 12px 0;\n  color: #495057;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.no-players-message {\n  text-align: center;\n  padding: 20px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.no-players-message p {\n  margin: 0;\n  font-size: 14px;\n}\n\n.breakdown-table {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  background: #dee2e6;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.breakdown-header {\n  display: grid;\n  grid-template-columns: 2fr 1.5fr 1fr 1fr 1fr;\n  gap: 1px;\n  background: #667eea;\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.breakdown-header > div {\n  padding: 8px 6px;\n  display: flex;\n  align-items: center;\n}\n\n.breakdown-row {\n  display: grid;\n  grid-template-columns: 2fr 1.5fr 1fr 1fr 1fr;\n  gap: 1px;\n  background: white;\n  transition: background-color 0.2s;\n}\n\n.breakdown-row:hover {\n  background-color: #f8f9fa;\n}\n\n.breakdown-row:nth-child(even) {\n  background-color: #f8f9fa;\n}\n\n.breakdown-row:nth-child(even):hover {\n  background-color: #e9ecef;\n}\n\n.breakdown-row > div {\n  padding: 8px 6px;\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  border-right: 1px solid #dee2e6;\n}\n\n.breakdown-row > div:last-child {\n  border-right: none;\n}\n\n.col-player {\n  flex-direction: column;\n  align-items: flex-start !important;\n}\n\n.player-name {\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 2px;\n}\n\n.skin-count {\n  font-size: 11px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.col-user {\n  color: #495057;\n}\n\n.user-name {\n  font-weight: 500;\n}\n\n.col-skin {\n  flex-direction: column;\n  align-items: flex-start !important;\n}\n\n.skin-amount {\n  font-weight: 600;\n  color: #6c5ce7;\n}\n\n.skin-percentage {\n  font-size: 11px;\n  color: #6c757d;\n}\n\n.no-skin {\n  color: #adb5bd;\n  font-style: italic;\n}\n\n.col-sawoff {\n  flex-direction: column;\n  align-items: flex-start !important;\n}\n\n.sawoff-amount {\n  font-weight: 600;\n  color: #fdcb6e;\n}\n\n.no-sawoff {\n  color: #adb5bd;\n  font-style: italic;\n}\n\n.col-total {\n  justify-content: flex-end !important;\n}\n\n.total-amount {\n  font-weight: 700;\n  color: #2c3e50;\n  font-size: 14px;\n}\n\n/* Verification Section */\n.verification-section {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n  margin-top: 20px;\n}\n\n.verification-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.verification-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px;\n  background: white;\n  border-radius: 6px;\n}\n\n.verification-item .label {\n  font-weight: 500;\n  color: #6c757d;\n}\n\n.verification-item .value {\n  font-weight: 700;\n  font-size: 16px;\n  color: #2c3e50;\n}\n\n.verification-item .value.success {\n  color: #00b894;\n}\n\n.verification-item .value.error {\n  color: #ff7675;\n}\n\n/* Prize Note */\n.prize-note {\n  background: #e3f2fd;\n  border-left: 4px solid #2196f3;\n  padding: 12px 16px;\n  border-radius: 4px;\n  margin-top: 20px;\n}\n\n.prize-note p {\n  margin: 0;\n  color: #1976d2;\n  font-size: 14px;\n}\n\n/* Modal Footer */\n.prize-v2-modal-footer {\n  padding: 20px 30px;\n  border-top: 2px solid #e0e0e0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  background: #f8f9fa;\n  border-radius: 0 0 12px 12px;\n}\n\n.btn-secondary {\n  padding: 10px 24px;\n  background: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-secondary:hover {\n  background: #5a6268;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .prize-v2-modal {\n    max-width: 100%;\n    margin: 10px;\n  }\n\n  .prize-summary-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .round-summary {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .prize-v2-modal-header h2 {\n    font-size: 20px;\n  }\n\n  .breakdown-header,\n  .breakdown-row {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n\n  .breakdown-header > div,\n  .breakdown-row > div {\n    padding: 6px 8px;\n    border-right: none;\n    border-bottom: 1px solid #dee2e6;\n  }\n\n  .breakdown-header > div:last-child,\n  .breakdown-row > div:last-child {\n    border-bottom: none;\n  }\n\n  .breakdown-header > div::before,\n  .breakdown-row > div::before {\n    content: attr(data-label) \": \";\n    font-weight: 600;\n    color: #6c757d;\n    margin-right: 8px;\n  }\n\n  .breakdown-header > div::before {\n    color: rgba(255, 255, 255, 0.8);\n  }\n\n  .col-player::before { content: \"Player: \"; }\n  .col-user::before { content: \"User: \"; }\n  .col-skin::before { content: \"Skin: \"; }\n  .col-sawoff::before { content: \"Saw-Off: \"; }\n  .col-total::before { content: \"Total: \"; }\n}\n\n@media (max-width: 480px) {\n  .prize-v2-modal-content {\n    padding: 20px;\n  }\n\n         .round-header {\n           padding: 8px 12px;\n           gap: 8px;\n         }\n\n  .expand-icon {\n    width: 20px;\n    height: 20px;\n    font-size: 16px;\n  }\n\n  .player-breakdown {\n    padding: 12px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
